import { z } from "zod";

export const movieSearchSchema = z.object({
	filterId: z.string().optional(),
	page: z.number().optional(),
	pageSize: z.number().optional(),
});
